import { StudySpace } from '@faro/study-space-service-model';
import axios from 'axios';

export interface StudySpaceQuery {
    studyDefinitionId?: string;
}

class StudySpaceClient {
    async list(params?: StudySpaceQuery, signal?: AbortSignal): Promise<StudySpace[]> {
        const response = await axios.get('/api/study-designer/study-spaces', {
            params,
            signal,
        });
        return response.data;
    }

    async get(query: { id: string }, signal?: AbortSignal): Promise<StudySpace> {
        const { id, ...params } = query;
        const response = await axios.get(`/api/study-designer/study-spaces/${id}`, {
            params,
            signal,
        });
        return response.data;
    }
}

export const studySpaceClient = new StudySpaceClient();
